import { render, staticRenderFns } from "./PIDJdTutorial.vue?vue&type=template&id=2a29976b&scoped=true"
import script from "./PIDJdTutorial.vue?vue&type=script&lang=js"
export * from "./PIDJdTutorial.vue?vue&type=script&lang=js"
import style0 from "./PIDJdTutorial.vue?vue&type=style&index=0&id=2a29976b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29976b",
  null
  
)

export default component.exports